<template>
    <v-dialog v-model="dialogueProp" width="1200" scrollable>
        <v-card>
            <v-toolbar class="close-btn" flat>
                <v-btn icon @click="dialogueProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <div v-if="getDependentMBL" class="util-container">
                <!-- Dependent MBL-->
                <div style="width:85%; margin:auto;">
                    <div v-if="dependentSelection === cardCount">
                        <div class="text-center mt-5">
                            <h3>{{ dependentName }}</h3>
                        </div>
                        <br>
                        <div v-if="getDependentMBL">
                            <div style="background-color: white; padding: 3px; border-radius: 5px;">
                                <v-alert
                                    color="teal darken-3"
                                    outlined
                                    style="margin: 0;"
                                    type="info"
                                >
                                    <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                                </v-alert>
                            </div>
                            <br>
                            <v-data-table
                                :headers="headers"
                                :items="getData"
                                :items-per-page="5"
                                no-data-text
                                :footer-props="footer_props"
                                class="my-10 elevation-10"
                            >
                                <template #item="{ item }">
                                    <tr v-if="screen_width < 600" class="mbl_tbl">
                                        <td>
                                            <ul>
                                                <li>Limit<span>{{ item.LIMIT }}</span></li>
                                                <li>Used<span>{{ item.USED }}</span></li>
                                                <li>Has Available?<span>{{ item.HAS_AVAILABLE }}</span></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td v-text="item.LIMIT"></td>
                                        <td v-text="item.USED"></td>
                                        <td v-text="item.HAS_AVAILABLE"></td>
                                    </tr>
                                </template>
                                <!--
                            <template slot="item" slot-scope="props">
                                <tr>
                                <td v-text="props.item.LIMIT" />
                                <td v-text="props.item.USED" />
                                <td v-text="props.item.HAS_AVAILABLE" />
                                </tr>
                            </template>
                                -->
                            </v-data-table>
                            <br>
                            <br>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['getDependentMBL', 'dependentSelection', 'cardCount', 'showDependentMBL', 'dependentName'],
    data: () => {
        return({
            mdiClose,
            screen_width: document.documentElement.clientWidth + 9,
            AR: null,
            footer_props: {
                'items-per-page-options': []
            },
            headers: [
                {
                    text: 'Max. Benefit Limit',
                    align: 'left',
                    value: 'LIMIT',
                    class: 'teal--text'
                },
                {
                    text: 'Used Benefits',
                    align: 'left',
                    value: 'USED',
                    class: 'teal--text'
                },
                {
                    text: 'Has Available?',
                    align: 'left',
                    value: 'HAS_AVAILABLE',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        getData: {
            get() {
                const obj = [{
                    LIMIT: this.getDependentMBL.LIMIT,
                    USED: this.getDependentMBL.USED,
                    HAS_AVAILABLE: this.getDependentMBL.HAS_AVAILABLE ? 'YES' : 'NO'
                }]
                return obj
            }
        },
        dialogueProp: {
            get() {
                return this.showDependentMBL && this.cardCount === this.dependentSelection
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>
<style scoped>
.close-btn{
  display: flex;
  align-items: right;
  justify-content: right;
}

.util-container {
  background-color:white;
}

.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

.mbl_tbl {
	/* background-color: red; */
	width: 100%;
}

.mbl_tbl td {
	/* background-color: blue; */
	width: 600px;
}

.mbl_tbl td ul {
	/* background-color: green; */
	margin-left: 0;
	padding-left: 0;
	list-style: none;
}

.mbl_tbl td ul li {
	margin: 10px 0;
	padding: 10px 0;
	text-align: left;
	/* background-color: brown; */
	position: relative;
	font-weight: bold;
}

.mbl_tbl td ul li span {
	text-align: right;
	font-weight: 400;
	/* background-color: pink; */
	position: absolute;
	right: 0;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
